import { render, staticRenderFns } from "./OrderPartnerDetail.vue?vue&type=template&id=f4dc1996&scoped=true&"
import script from "./OrderPartnerDetail.vue?vue&type=script&lang=js&"
export * from "./OrderPartnerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dc1996",
  null
  
)

export default component.exports